import { localize } from "@/i18n/translate";
import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LangContext";
export const Footer = () => {
  const { lang } = useLang();
  const en = lang !== "de";
  return (
    <footer className="heritage-footer">
      <div className="heritage-footer-inner">
        <div>
          <img src="/brand/logo.svg" alt={localize("Swiss Blockchain Alliance")} width="762" height="208" />
          <p>{localize(en ? 'Structured, reliable, long-term protection for critical digital infrastructures. Security, stability and trust in a constantly evolving digital environment.' : 'Strukturierter, zuverlässiger und langfristiger Schutz für kritische digitale Infrastrukturen. Sicherheit, Stabilität und Vertrauen in einem sich ständig weiterentwickelnden digitalen Umfeld.')}</p>
          <div className="heritage-footer-partners" aria-label={localize("Organization logos")}>
            <img src="/brand/bafin-logo.png" alt="BaFin" width="220" height="72" loading="lazy" decoding="async" />
            <img src="/brand/swiss-confederation-logo.png" alt={localize("Swiss Confederation")} width="220" height="72" loading="lazy" decoding="async" />
            <img src="/brand/finma-logo.png" alt="FINMA" width="220" height="72" loading="lazy" decoding="async" />
            <img src="/brand/alliance-logo-small.png" alt={localize("Swiss Blockchain Alliance")} width="220" height="72" loading="lazy" decoding="async" />
          </div>
        </div>
        <div>
          <h2>{localize(en ? 'Explore' : 'Navigation')}</h2>
          <Link to="/">{localize("Home")}</Link>
          <Link to="/#publikationen">{localize(en ? 'News & activities' : 'Neuigkeiten & Aktivitäten')}</Link>
          <Link to="/#organisation">{localize("Organisation")}</Link>
          <Link to="/#mitgliedschaft">{localize(en ? 'Membership' : 'Mitgliedschaft')}</Link>
          <Link to="/impressum">{localize("Impressum")}</Link>
          <Link to="/datenschutz">{localize(en ? 'Privacy policy' : 'Datenschutz')}</Link>
          <a href="/cookies-policy">{localize(en ? 'Cookies policy' : 'Cookie-Richtlinie')}</a>
          <a href="/disclaimer">{localize("Disclaimer")}</a>
        </div>
        <div>
          <h2>{localize(en ? 'Get in touch' : 'Kontakt')}</h2>
          <a href="mailto:info@swissblockchainalliance.com">{localize("info@swissblockchainalliance.com")}</a>
          <a href="tel:+41613002840">+41 61 300 28 40</a>
          <a href="tel:+41265006929">+41 26 500 69 29</a>
          <address>{localize("Schauplatzgasse 39")}<br />{localize("3011 Bern, Schweiz")}</address>
          <Link to="/kundenbereich">{localize(en ? 'Client login' : 'Kundenbereich')} ↗</Link>
        </div>
      </div>
      <div className="heritage-copyright">
        © {localize(new Date().getFullYear())}{localize(" Swiss Blockchain Alliance ")}
        <span>{localize("Bern \xB7 Switzerland")}</span>
      </div>
    </footer>
  );
};
